<!--
  固定长度的 el-tooltip 超出长度显示 否则禁用
-->
<script>
export default {
  name: 'FixedTooltip',
  props: {
    width: {
      type: String,
      default: '200px'
    },
    content: {
      type: String,
      default: ''
    },
    wrapClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      disabled: false
    }
  },
  mounted() {
    const scrollWidth = this.$refs.wrapRef.scrollWidth
    this.disabled = scrollWidth <= parseInt(this.width)
  }
}
</script>

<template>
  <el-tooltip :disabled="disabled" :content="content" popper-class="fixed-tooltip">
    <div
        :style="{maxWidth:width}"
        class="truncate inline-block box-border"
        :class="wrapClass"
        ref="wrapRef"
    >
      <slot name="default"></slot>
    </div>
  </el-tooltip>
</template>

